import React from 'react';
import { Redirect, Switch, useLocation } from 'react-router-dom';

import routesPath from '~/constants/routes';
import Route from './Route';
import {
  Login,
  Register,
  RegisterConfirmation,
  PasswordRecovery,
  Dashboard,
  Match,
  NotFound,
  ChangePassword,
  ConfirmCode,
  PrivateDocuments,
  Failure,
} from '~/pages';
import ErrorPage from '~/pages/ErrorPage';

export default function Routes() {
  const { pathname } = useLocation();
  return (
    <Switch>
      <Redirect from="/:url*(/+)" to={pathname.slice(0, -1)} />
      <Route path={routesPath.login} exact component={Login} />
      <Route path={routesPath.confirm} component={ConfirmCode} />
      <Route path={routesPath.register} component={Register} />
      <Route path={routesPath.confirmation} component={RegisterConfirmation} />
      <Route path={routesPath.passwordRecovery} component={PasswordRecovery} />
      <Route path={routesPath.changePassword} component={ChangePassword} />
      <Route path={routesPath.failure} component={Failure} />
      <Route path={routesPath.error} component={ErrorPage} />
      <Route path={routesPath.dashboard} component={Dashboard} isPrivate />
      <Route path={routesPath.match} component={Match} isPrivate />
      <Route
        path={routesPath.privateDocs}
        component={PrivateDocuments}
        isPrivate
      />
      <Route component={NotFound} />
    </Switch>
  );
}
